export const appProduction = process.env.APP_PRODUCTION === 'true';
export const appSystemKey = process.env.APP_SYSTEM_KEY || '';
export const appGenericKey = null;
export const appBrowser = process.env.APP_BROWSER === 'true';
export const appDebug = process.env.APP_DEBUG === 'true';
export const appApiURL = process.env.APP_API_URL || '';
export const appGoogleMapsApiKey = process.env.APP_GOOGLE_MAPS_API_KEY || '';
export const appOnePush = process.env.APP_ONESIGNAL_UID || '';

// Get both bundle IDs from environment
const defaultBundleId = process.env.APP_BUNDLE_ID || '';
const androidAppId = process.env.APP_AND_APP_ID || '';

// Use APP_AND_APP_ID if it exists and is different from APP_BUNDLE_ID
export const appBundleID = (androidAppId && androidAppId !== defaultBundleId) 
    ? androidAppId 
    : defaultBundleId;

export const appName = process.env.APP_NAME || '';